import uuid from 'uuid/v4';

/**
 * Creates the chat channelID for use with ConvoAI/assistance-service API.
 */
export var buildChannelId = function buildChannelId() {
  return uuid();
};